import styled from "styled-components";

const ScormCoursesContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ProgressBarScormContainer = styled.div`
  margin-top: 15px;
`;

export { ScormCoursesContainer, ProgressBarScormContainer };
